<template>
  <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0">
    <v-app-bar
      v-if="selectedTabData.loadingProgress == 100"
      outlined
      flat
      color="white"
      height="52px"
      style="border-bottom: 1px solid #ededed !important; z-index: 99"
    >
      <IconTooltipButtonBottom
        icon="mdi-arrow-left"
        tooltip="Zurück zur Liste"
        id="default"
        width="50px"
        large
        @click="onBackButtonClicked"
      />
      <v-spacer></v-spacer>
      <div>
        <v-chip
          small
          v-if="selectedTabData.pxMode"
          label
          color="lightgreen_s"
          text-color="lightgreen"
          class="text-uppercase text-black font-xs mr-2"
          style="padding: 4px 6px"
        >
          <v-icon small class="mr-1">mdi-emoticon-happy-outline</v-icon>
          <span style="font-size: 10px">PX Modus</span>
        </v-chip>
        <span v-if="selectedTabData.editingMode">
          <v-icon color="primary" style="transform: rotate(-90deg)" class="mr-2"
            >mdi-sitemap</v-icon
          >
        </span>
        <span class="mr-2 h4">{{ selectedTabData.fileName }}</span>
        <span v-if="!selectedTabData.pxMode">
          <span
            v-if="selectedTabData && selectedTabData.editingMode"
            class="text-tag"
            >.bpmn</span
          >
        </span>
      </div>
      <v-spacer
        :style="'flex-grow: ' + setSpacerMargin() + ' !important;'"
      ></v-spacer>
      <!--      Edit & Viewer Mode-->
      <div id="modelingButtons" v-if="!selectedTabData.pxMode" class="mr-4">
        <IconTooltipButtonBottom
          icon="mdi-menu"
          tooltip="Menü öffnen"
          id="default"
          v-if="!showSidePanel"
          @click="showSidePanel = true"
        />
        <IconTooltipButtonBottom
          icon="mdi-menu"
          tooltip="Menü schließen"
          id="default"
          color="primary"
          v-if="showSidePanel"
          @click="showSidePanel = false"
        />
        <IconTooltipButtonBottom
          icon="mdi-content-save-outline"
          :tooltip="$t('save')"
          id="default"
          v-if="
            selectedTabData &&
            selectedTabData.editingMode &&
            selectedTabData.modelInformation &&
            (!selectedTabData.modelInformation.releaseEnabled ||
              editAfterPublish)
          "
          @click="saveFile()"
        />
        <IconTooltipButtonBottom
          v-if="canEdit"
          icon="mdi-share-variant"
          tooltip="Teilen"
          id="default"
          @click="showProcessSharedialog = !showProcessSharedialog"
        />

        <IconTooltipButtonBottom
          v-if="canEdit"
          icon="mdi-account-group"
          tooltip="Freigegebene Nutzer"
          id="default"
          @click="showUserListDialog = !showUserListDialog"
        />

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom>
              <template #activator="{ on: onTooltip }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="{ ...on, ...onTooltip }"
                  id="default"
                  style="padding: unset !important; width: 40px"
                >
                  <v-icon>mdi-export</v-icon>
                </v-btn>
              </template>

              <span>Exportieren</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item @click="exportPDF()">
              <v-list-item-title>PDF-Datei</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canEdit" @click="exportXML()">
              <v-list-item-title>XML-Datei</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canEdit" @click="generateReport()">
              <v-list-item-title>Bericht erstellen</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <IconTooltipButtonBottom
          icon="mdi-clipboard-text-clock-outline"
          tooltip="Historie"
          id="default"
          @click="tooling = 'history'"
        />
      </div>
      <!--      PX Mode-->
      <div
        id="modelingButtons"
        v-if="selectedTabData.pxMode && selectedTabData.pxWrite"
        class="mr-4"
      >
        <IconTooltipButtonBottom
          icon="mdi-menu"
          tooltip="Menü öffnen"
          id="default"
          v-if="!showSidePanel"
          @click="openQuestionPanel()"
          :disabled="selectedTabData.showEvaluation && modelDiffrent"
        />
        <IconTooltipButtonBottom
          icon="mdi-menu"
          tooltip="Menü schließen"
          id="default"
          color="primary"
          v-if="showSidePanel"
          @click="openQuestionPanel()"
          :disabled="selectedTabData.showEvaluation && modelDiffrent"
        />
        <IconTooltipButtonBottom
          icon="mdi-checkbox-marked"
          tooltip="Fragen"
          id="default"
          @click="openQuestionPanel()"
          :disabled="selectedTabData.showEvaluation && modelDiffrent"
        />

        <IconTooltipButtonBottom
          icon="mdi-format-list-text"
          tooltip="Fragenübersicht anzeigen"
          id="default"
          @click="showSurveyPreview()"
          :disabled="selectedTabData.showEvaluation && modelDiffrent"
        />

        <IconTooltipButtonBottom
          icon="mdi-list-box-outline"
          tooltip="Umfrage erstellen"
          id="default"
          @click="generateSurvey()"
          :disabled="selectedTabData.showEvaluation && modelDiffrent"
        />
      </div>
      <div v-if="!selectedTabData.pxMode">
        <v-btn
          v-if="
            !selectedTabData.editingMode &&
            canEdit &&
            selectedTabData.modelInformation &&
            (!selectedTabData.modelInformation.releaseEnabled ||
              (selectedTabData.modelInformation.releaseEnabled &&
                canIssueReleaseRequest))
          "
          elevation="0"
          color="primary"
          @click="showConfirmEditMode()"
        >
          <v-icon small color="white" class="mr-1">mdi-pencil</v-icon>
          Bearbeiten
        </v-btn>
        <v-btn
          v-if="
            selectedTabData &&
            selectedTabData.editingMode &&
            selectedTabData.modelInformation &&
            (!selectedTabData.modelInformation.releaseEnabled ||
              editAfterPublish)
          "
          elevation="0"
          color="primary"
          @click="endEditing()"
        >
          <v-icon small color="white" class="mr-1">mdi-pencil-off</v-icon>
          Bearbeitung beenden
        </v-btn>
        <IconTooltipButtonBottom
          icon="mdi-content-save-outline"
          tooltip="Zwischenspeichern"
          id="default"
          v-if="
            selectedTabData &&
            selectedTabData.editingMode &&
            selectedTabData.modelInformation &&
            selectedTabData.modelInformation.releaseEnabled &&
            !editAfterPublish
          "
          @click="saveReviewFile()"
        />
        <v-btn
          v-if="
            selectedTabData &&
            selectedTabData.editingMode &&
            selectedTabData.modelInformation &&
            selectedTabData.modelInformation.releaseEnabled &&
            !editAfterPublish
          "
          elevation="0"
          color="primary"
          @click="publishFile(selectedTabData)"
        >
          <v-icon small color="white" class="mr-1"
            >mdi-file-upload-outline</v-icon
          >
          Freigabeanfrage senden
        </v-btn>
      </div>
    </v-app-bar>
    <div
      id="numerationDisplay"
      v-if="
        selectedTabData &&
        !selectedTabData.editingMode &&
        selectedTabData.modelInformation &&
        !editAfterPublish &&
        selectedTabData.loadingProgress == 100
      "
    >
      <v-switch
        v-model="selectedTabData.showNumbers"
        color="primary"
        :label="false"
        class="ma-0 pa-0"
      >
        <template #label>
          <span>
            {{
              selectedTabData.showNumbers
                ? "Elementnummerierung ausblenden"
                : "Elementnummerierung anzeigen"
            }}
            <v-tooltip bottom max-width="400">
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                  medium
                  color="primary"
                >
                  mdi-help-circle
                </v-icon>
              </template>
              <span class="tooltip-text">
                <strong
                  >Die Elementnummerierung dient der Anordnung der Elemente im
                  Bericht.</strong
                ><br />
                Für die Nummerierung sind nur Zahlen erlaubt. Abzweigungen
                können mit Punkt-getrennten Nummern dargestellt werden, zum
                Beispiel: 4.1, 4.2, usw.<br />
                Um eine Nummer zu ändern, klicken Sie auf das entsprechende
                Feld, geben die neue Nummer ein und drücken
                <strong>Enter</strong>, um die Änderung zu speichern.
              </span>
            </v-tooltip>
          </span>
        </template>
      </v-switch>
    </div>
    <div
      v-if="
        (selectedTabData.pxEval || selectedTabData.pxWrite) &&
        selectedTabData.modelInformation &&
        (!selectedTabData.modelInformation.releaseEnabled || editAfterPublish)
      "
      id="modelingBar"
    >
      <v-switch
        v-model="selectedTabData.pxMode"
        color="primary"
        label="PX Modus"
        class="ma-0 pa-0"
      ></v-switch>
    </div>
    <vue-tabs-chrome
      theme="custom"
      id="tabs"
      ref="tab"
      v-model="tab"
      :tabs="tabs"
      @removeTab="removeTab"
    >
    </vue-tabs-chrome>
    <div
      v-if="selectedTabData.loadingProgress == 100"
      id="left"
      :class="[showSidePanel ? 'commentsOpened' : 'commentsClosed']"
    >
      <BpmnViewer
        ref="bpmnViewer"
        :diagramXML="diagramXML"
        :elementsToLabel="selectedTabData.elementsToLabel"
        :evalMode="selectedTabData.showEvaluation"
        v-if="selectedTabData && !selectedTabData.editingMode"
        class="fill-height"
        @elementClicked="onElementClicked"
        @createBadge="setBadgesForMode"
        @createEvaluationBadge="setEvaluationBadge"
        @hideEvaluationBadges="hideEvaluationBadge"
        @switchModel="openNewModel"
      />
      <BpmnEditor
        ref="bpmnEditor"
        :diagramXML="selectedTabData.diagramXML"
        v-if="selectedTabData && selectedTabData.editingMode"
        class="fill-height"
        @elementClicked="onElementClicked"
        @createBadge="setBadgesForMode"
        @saveFile="saveFile(true)"
        @switchModel="openNewModel"
      />

      <ProcessShareDialog
        v-model="showProcessSharedialog"
        :uuid="selectedTabData.uuid"
      />
      <UserListDialog
        v-model="showUserListDialog"
        :uuid="selectedTabData.uuid"
      />
      <ConfirmDialog ref="confirmDialog" />
      <InfoDialog ref="infoDialog" />
    </div>
    <div id="right" v-if="showSidePanel" style="margin-top: 1px">
      <ProcessModelingSidePanel
        :selectedTabData="selectedTabData"
        :canEdit="canEdit"
        @processChanged="processChanged"
        @saveFile="saveFile"
      />
    </div>
    <HistorySection
      v-if="tooling == 'history'"
      :canEdit="canEdit"
      :uuid="selectedTabData.uuid"
      ref="history"
      :fileName="selectedTabData.fileName"
      v-on:changed="processChanged(true)"
      @closeHistory="closeHistory()"
    />
    <v-progress-linear
      :style="
        'position: absolute; bottom: 0; display:' +
        (selectedTabData.loadingProgress == 100
          ? 'none;'
          : 'block; z-index:99;')
      "
      color="gray accent-4"
      :indeterminate="selectedTabData.loadingProgress == 100 ? false : true"
      height="4"
      :value="selectedTabData.loadingProgress"
    ></v-progress-linear>
    <div
      :class="
        showSidePanel ? 'sidePanelExpand pointer' : 'sidePanelCollapsed pointer'
      "
      @click="showSidePanel = !showSidePanel"
    >
      <div v-if="!showSidePanel">
        <v-icon color="secondary" large>mdi-chevron-left</v-icon>
      </div>
      <div v-if="showSidePanel">
        <v-icon color="secondary" large>mdi-chevron-right</v-icon>
      </div>
    </div>
    <AddSurveyTextDialog ref="formDialog" />
    <ShowQuestionsPreview
      ref="questionPreview"
      @generateSurvey="setSurveyTitle"
      @questionsChanged="processChanged"
    />
    <PxModeEvaluationPanel
      v-if="selectedTabData.pxMode && selectedTabData.pxEval"
      :uuid="selectedTabData.uuid"
      :context-informations="selectedTabData.contextInfo"
      :survey-evaluations="evaluations"
      @toggleEvaluation="toggleEvaluation"
      @showSidePanel="showSidePanel = false"
      :surveyId="selectedTabData.preselectedSurvey"
    />
    <PxElementQuestionEvaluationPanel ref="elementQuestionEvaluation" />
    <publish-dialog ref="publishDialog" />
    <div>
      <v-row v-if="selectedTabData.showEvaluation" class="evaluationText">
        <v-col cols="1">
          <v-icon color="primary">mdi-comment-alert</v-icon>
        </v-col>
        <v-col cols="11">
          Die Kennzahlen des Prozessmodells werden ausschließlich mit
          Matrixfragen berechnet. Um die Auswertung aller Fragen zu sehen
          <b>klicken Sie auf eine der Kennzahlen</b>
        </v-col>
      </v-row>
    </div>
    <div
      v-if="
        !editAfterPublish &&
        selectedTabData.modelInformation &&
        selectedTabData.modelInformation.releaseEnabled &&
        selectedTabData.modelInformation.reviewRequests.length > 0 &&
        !canIssueReleaseRequest
      "
    >
      <v-row class="evaluationText">
        <v-col cols="1">
          <v-icon color="primary">mdi-comment-alert</v-icon>
        </v-col>
        <v-col cols="11">
          Eine neuere Version dieses Prozessmodells befindet sich gerade im
          Freigabeprozess. Sie sehen die letzte freigegebene Version
        </v-col>
      </v-row>
    </div>
    <div
      v-if="
        !editAfterPublish &&
        selectedTabData.modelInformation &&
        selectedTabData.modelInformation.releaseEnabled &&
        canIssueReleaseRequest
      "
    >
      <v-row class="evaluationText">
        <v-col cols="1">
          <v-icon color="primary">mdi-comment-alert</v-icon>
        </v-col>
        <v-col cols="11">
          Für diesen Prozess ist der Freigabeprozess aktiviert. Sie können den
          Prozess bearbeiten und ihre Änderungen zur Prüfung an den
          Prozessverantwortlichen versenden.
        </v-col>
      </v-row>
    </div>

    <div
      v-if="
        editAfterPublish &&
        selectedTabData.modelInformation &&
        selectedTabData.modelInformation.releaseEnabled
      "
    >
      <v-row class="evaluationText">
        <v-col cols="1">
          <v-icon color="primary">mdi-comment-alert</v-icon>
        </v-col>
        <v-col cols="11">
          Für diesen Prozess ist der Freigabeprozess aktiviert. Sie haben diese
          Version freigegeben und können diese nun nachbearbeiten. Die
          Möglichkeit zur Nachbearbeitung endet wenn Sie diesen Bildschirm
          verlassen.
        </v-col>
      </v-row>
    </div>
    <v-snackbar
      location="center"
      rounded="pill"
      v-model="snackbar.value"
      outlined
      timeout="-1"
      :color="snackbar.status"
      class="mb-12"
    >
      <span class="middle-aligned">
        <v-progress-circular
          v-if="snackbar.loading"
          indeterminate
          :color="snackbar.status"
        ></v-progress-circular>
        <v-icon v-if="snackbar.icon" :color="snackbar.status">{{
          snackbar.icon
        }}</v-icon>
        {{ snackbar.msg }}
      </span>
    </v-snackbar>
    <LoadingOverlay :dialog="numbersLoading" />
  </div>
</template>

<script>
import ProcessShareDialog from "./ProcessShareDialog";
import UserListDialog from "./UserListDialog";
import ConfirmDialog from "@/components/common/ConfirmDialog";
import InfoDialog from "@/components/common/InfoDialog";

import processModelingService from "./process-modeling-service";
import { hasSeenDialog, markDialogAsSeen } from "@/components/modalService";

import IconTooltipButton from "@/components/common/IconTooltipButton";
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom";

import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
import BpmnEditor from "@/pages/ProcessModeling/BpmnEditor";
import HistorySection from "@/pages/ProcessModeling/Menu/HistorySection/HistorySection";
import historyService from "./Menu/HistorySection/history-service";

import CommentsSection from "@/pages/ProcessModeling/Menu/CommentsSection/CommentsSection";
import QuestionSection from "@/pages/ProcessModeling/Menu/QuestionSection/QuestionSection";
import DocumentSection from "@/pages/ProcessModeling/Menu/DocumentSection/DocumentSection.vue";
import PxQuestionSection from "@/pages/ProcessModeling/Menu/PxQuestionSection/PxQuestionSection.vue";

import VueTabsChrome from "vue-tabs-chrome";
import { hexToRgb, getContrastColor } from "@/components/colorContrast.js";
import PreviewProcessModelDialog from "../../components/PreviewProcessModelDialog.vue";

import AddSurveyTextDialog from "@/components/common/AddSurveyTextDialog.vue";

import surveyEvaluationService from "@/components/surveyEvaluationService";
import pxQuestionService from "@/pages/PxQuestionSurvey/PXQuestionsPage/px-question-service";
import surveyGenerator from "@/components/px-survey-generator";
import ShowQuestionsPreview from "./Menu/PxMode/ShowQuestionsPreview.vue";

import pxSurveyService from "@/pages/PxQuestionSurvey/PXSurveyPage/px-survey-service";
import PxModeEvaluationPanel from "./Menu/PxMode/PxModeEvaluationPanel.vue";
import PxElementQuestionEvaluationPanel from "./Menu/PxMode/PxElementQuestionEvaluationPanel.vue";

import { getBusinessObject } from "prime-custom-modeling/lib/util/ModelUtil";
import ElementDescriptionSection from "./Menu/ElementDescriptionSection/ElementDescriptionSection.vue";
import PublishDialog from "./Review/PublishDialog.vue";
import { generateReportStructure } from "@/components/util.js";
import ProcessModelingSidePanel from "./ProcessModelingSidePanel.vue";

import elementNumberService from "@/components/elementNumberService";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import MngmtLinkSectionVue from "./Menu/MngmtLinkSection/MngmtLinkSection.vue";
export default {
  components: {
    LoadingOverlay,
    ProcessShareDialog,
    UserListDialog,
    IconTooltipButton,
    IconTooltipButtonBottom,
    ConfirmDialog,
    InfoDialog,
    BpmnViewer,
    BpmnEditor,
    CommentsSection,
    HistorySection,
    DocumentSection,
    QuestionSection,
    PxQuestionSection,
    VueTabsChrome,
    PreviewProcessModelDialog,
    AddSurveyTextDialog,
    ShowQuestionsPreview,
    PxModeEvaluationPanel,
    PxElementQuestionEvaluationPanel,
    ElementDescriptionSection,
    PublishDialog,
    ProcessModelingSidePanel,
  },
  data: function () {
    return {
      showProcessSharedialog: false,
      showUserListDialog: false,
      fileName: String,
      showSidePanel: false,
      showQuestionPanel: false,
      badgeColor: "#" + this.$store.state.clientColor,
      canEdit: false,
      tabs: [],
      tab: "",
      sidemenuTab: "comment",
      selectedTabData: [],
      tooling: "",
      tabNames: {
        comments: "Kommentare",
        documents: "Dokumente",
        pxQuestions: "Process Experience Fragen",
      },
      evaluations: [],
      snackbar: {
        value: false,
        status: "secondary",
        msg: "",
        loading: false,
        icon: null,
      },
      editAfterPublish: false,
      elementRegistry: null,
      wantedElements: [
        "bpmn:Task",
        "bpmn:Activity",
        "bpmn:Gateway",
        "bpmn:SubProcess",
        "bpmn:EventSubProcess",
      ],
      numbersLoading: false,
    };
  },
  updated() {
    let rgbPrimary = hexToRgb(this.$vuetify.theme.themes.light.primary);
    let foregroundColor = getContrastColor(rgbPrimary);

    if (document.getElementById("editTooltip") != null)
      document.getElementById("editTooltip").style.color = foregroundColor;
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.selectedTabData &&
      this.selectedTabData.editingMode &&
      (!this.selectedTabData.modelInformation.releaseEnabled ||
        this.editAfterPublish)
    ) {
      //this.saveFile();
      this.endEditing();
      next();
    }
    if (
      this.selectedTabData &&
      this.selectedTabData.editingMode &&
      this.selectedTabData.modelInformation.releaseEnabled &&
      !this.editAfterPublish
    ) {
      processModelingService
        .setEditingMode(this.selectedTabData.uuid, null)
        .then(() => {
          this.selectedTabData.editingMode = false;
          next();
        });
    } else {
      next();
    }
  },
  async mounted() {
    this.editAfterPublish = JSON.parse(
      localStorage.getItem("editAfterPublish")
    );
    this.$store
      .dispatch("checkFolderPermission", {
        processId: this.uuid,
        permission: "PROCESS_WRITE",
      })
      .then((res) => {
        this.canEdit = res;
      });
    if (this.uuid) {
      surveyEvaluationService
        .retrieveSurveyAnswersForProcess(this.uuid)
        .then((res) => {
          this.evaluations = res.data;
        });
      processModelingService.getProcessXml(this.uuid).then(async (res) => {
        const elementsWithAttachments =
          await processModelingService.getElementsWithAttachments(this.uuid);
        var elementsToLabel = elementsWithAttachments.data;
        let diagramXML = res.data;
        processModelingService
          .retrieveModelInformation(this.uuid)
          .then(async (result) => {
            let contextInfo = result.data.information;
            let fileName = result.data.fileName;
            let editingMode = false;
            if (
              result.data.currentEditor &&
              result.data.currentEditor === this.userId
            ) {
              editingMode = true;
            } else {
              editingMode = false;
            }
            await this.initTabs(
              fileName,
              diagramXML,
              elementsToLabel,
              editingMode,
              contextInfo
            );
            await this.fetchDiagram();
            this.fileName = fileName;
            if (this.editAfterPublish) {
              this.editModel();
            }
          });
      });
    }
  },
  watch: {
    uuid: function (val) {
      this.$emit("loading");
      //if (val) this.fetchDiagram();
    },
    tab(val) {
      this.selectedTabData = this.tabs.find((item) => item.key === val);
      this.selectedTabData.loadingProgress = 100;
    },
    "selectedTabData.pxMode"() {
      if (!this.selectedTabData.pxMode) {
        this.$refs.elementQuestionEvaluation.close();
        this.selectedTabData.showEvaluation = false;
        this.toggleEvaluation();
      }
      if (this.selectedTabData.pxMode && this.selectedTabData.editingMode)
        this.endEditing();
      if (this.selectedTabData.editingMode) {
        if (this.$refs.bpmnEditor) this.$refs.bpmnEditor.setBadges();
      } else {
        if (this.$refs.bpmnViewer) this.$refs.bpmnViewer.setBadges();
      }
    },
    "selectedTabData.showNumbers"() {
      this.selectedTabData.loadingProgress = 0;
      this.selectedTabData.loadingProgress = 100;
      if (this.selectedTabData.editingMode) {
        return;
      } else {
        if (this.$refs.bpmnViewer) this.$refs.bpmnViewer.setBadges();
      }
    },
  },
  computed: {
    userId() {
      return this.$store.getters.user.username;
    },
    uuid() {
      return this.$route.params.uuid;
    },
    isNew() {
      return this.$route.params.isNew == null
        ? false
        : this.$route.params.isNew;
    },
    diagramXML() {
      if (this.selectedTabData.pxMode && this.selectedTabData.showEvaluation) {
        return this.selectedTabData.surveyModel;
      } else {
        return this.selectedTabData.diagramXML;
      }
    },
    modelDiffrent() {
      if (this.selectedTabData.surveyModel == null) return false;
      return (
        this.selectedTabData.surveyModel != this.selectedTabData.diagramXML
      );
    },
    canIssueReleaseRequest() {
      if (
        this.selectedTabData &&
        this.selectedTabData.modelInformation &&
        this.selectedTabData.modelInformation.reviewRequests.length == 0
      )
        return true;
      /*       if(this.selectedTabData && this.selectedTabData.modelInformation && this.selectedTabData.modelInformation.reviewRequests){
        return this.selectedTabData.modelInformation.reviewRequests.some(item => item.initiator == this.userId);
      } */
    },
  },
  methods: {
    generateReportStructure: generateReportStructure,
    closeHistory() {
      this.tooling = "";
    },
    async initTabs(
      fileName,
      diagramXML,
      elementsToLabel,
      editingMode,
      contextInfo
    ) {
      this.tabs = [];
      let pxWrite = await this.$store.dispatch("checkFolderPermission", {
        processId: this.uuid,
        permission: "PX_WRITE",
      });
      let pxEval = await this.$store.dispatch("checkFolderPermission", {
        processId: this.uuid,
        permission: "PX_EVAL",
      });
      let modelInformation =
        await processModelingService.retrieveModelInformation(this.uuid);

      let newTabs = [
        {
          label: fileName,
          key: this.uuid,
          uuid: this.uuid,
          closable: false,
          diagramXML: diagramXML,
          elementsTolabel: elementsToLabel,
          editingMode: editingMode,
          fileName: fileName,
          contextInfo: contextInfo,
          selectedElement: null,
          showEvaluation: false,
          pxMode: false,
          loadingProgress: 0,
          preselectedSurvey: null,
          pxWrite: pxWrite,
          pxEval: pxEval,
          modelInformation: modelInformation.data,
          showNumbers: false,
        },
      ];
      this.tabs.push(...newTabs);
      this.tab = this.uuid;
      this.selectedTabData = newTabs[0];
    },
    async openNewModel(uuid) {
      let alreadyOpened = this.tabs.find((item) => item.key === uuid);
      if (alreadyOpened != null) {
        this.tab = uuid;
        this.selectedTabData = alreadyOpened;
        return;
      }
      this.selectedTabData.loadingProgress = 0;

      let pxWrite = await this.$store.dispatch("checkFolderPermission", {
        processId: uuid,
        permission: "PX_WRITE",
      });
      let pxEval = await this.$store.dispatch("checkFolderPermission", {
        processId: uuid,
        permission: "PX_EVAL",
      });
      processModelingService.getProcessXml(uuid).then(async (result) => {
        var diagramXML = result.data;
        const elementsWithAttachments =
          await processModelingService.getElementsWithAttachments(uuid);
        var elementsToLabel = elementsWithAttachments.data;

        processModelingService
          .retrieveModelInformation(uuid)
          .then(async (result) => {
            let fileName = result.data.fileName;
            let contextInfo = result.data.information;
            let editingMode = false;
            if (
              result.data.currentEditor &&
              result.data.currentEditor === this.userId
            ) {
              editingMode = true;
            } else {
              editingMode = false;
            }
            let modelInformation =
              await processModelingService.retrieveModelInformation(this.uuid);
            let newTab = {
              label: fileName,
              key: uuid,
              uuid: uuid,
              closable: true,
              diagramXML: diagramXML,
              elementsToLabel: elementsToLabel,
              editingMode: editingMode,
              fileName: fileName,
              contextInfo: contextInfo,
              selectedElement: null,
              showEvaluation: false,
              pxMode: false,
              loadingProgress: 0,
              preselectedSurvey: null,
              pxWrite: pxWrite,
              pxEval: pxEval,
              showNumbers: false,
              modelInformation: modelInformation.data,
            };

            this.$refs.tab.addTab(newTab);
            this.selectedTabData = newTab;
            this.tab = uuid;
            this.selectedTabData.loadingProgress = 100;
          });
      });
    },
    removeTab() {
      this.$refs.tab.removeTab(this.tab);
    },
    onElementClicked(value) {
      this.selectedTabData.selectedElement = value;
      if (this.selectedTabData.selectedElement)
        this.loadColoredElements(this.selectedTabData.selectedElement.id);
    },
    onBackButtonClicked() {
      const infoMessage =
        "Die Bearbeitung des Modells wird automatisch gestoppt und für andere Nutzer freigegeben.";
      const promise = hasSeenDialog("EXIT_EDIT")
        ? Promise.resolve()
        : this.$refs.infoDialog
            .open("Bearbeitung wird beendet", infoMessage)
            .then(() => {
              markDialogAsSeen("EXIT_EDIT");
            });

      promise.then(() => this.$router.push("/processList"));
    },
    async endEditing() {
      if (
        (this.selectedTabData.modelInformation &&
          !this.selectedTabData.modelInformation.releaseEnabled) ||
        this.editAfterPublish
      ) {
        this.$route.params.isNew = false;
        this.$route.params.changeEditor = true;
        await this.saveFile(false);
      } else {
        processModelingService
          .setEditingMode(this.selectedTabData.uuid, null)
          .then(() => {
            this.selectedTabData.editingMode = false;
            if (
              (this.selectedTabData.modelInformation &&
                !this.selectedTabData.modelInformation.releaseEnabled) ||
              this.editAfterPublish
            ) {
              localStorage.setItem("editAfterPublish", false);
              this.editAfterPublish = false;
              this.fetchDiagram();
            }
          });
      }
    },
    showConfirmEditMode() {
      processModelingService
        .retrieveModelInformation(this.uuid)
        .then((result) => {
          if (
            !result.data.currentEditor ||
            result.data.currentEditor === this.userId
          ) {
            this.$refs.confirmDialog
              .open(
                "Bearbeiten",
                "Indem Sie das Prozessmodell bearbeiten, wird es für andere Nutzer für die Bearbeitung gesperrt."
              )
              .then(() => this.editModel());
          } else {
            const currentEditor = result.data.currentEditor;
            const infoMessage =
              "Das Prozessmodell wird gerade von folgendem Nutzer bearbeitet: " +
              currentEditor;
            this.$refs.infoDialog.open(
              "Bearbeitung nicht möglich",
              infoMessage
            );
          }
        });
    },
    editModel() {
      this.selectedTabData.showNumbers = false;
      processModelingService
        .setEditingMode(this.selectedTabData.uuid, this.userId)
        .then(() => {
          processModelingService
            .checkTmpModel(this.selectedTabData.uuid)
            .then((res) => {
              if (res.data != null && res.data != "")
                this.selectedTabData.diagramXML = res.data;
            });
          this.showEditConfirmation = false;
          this.selectedTabData.editingMode = true;
        });
    },
    setEvaluationBadge(overlays, elementRegistry) {
      let self = this;
      let elements = elementRegistry.getAll();
      elements.forEach((elem) => overlays.remove({ element: elem.id }));
      if (this.selectedTabData.evalData == null) return;
      let type = "eval";
      this.selectedTabData.evalData.forEach((score) => {
        const badge = processModelingService.createEvaluationBadge(
          score.overallScore
        );

        if (elementRegistry.get(score.elementId)) {
          badge.html.click(function (e) {
            self.badgeClicked(elementRegistry.get(score.elementId), type);
          });
          let overlayId = overlays.add(score.elementId, badge);
          score.overlay = {
            type: type,
            id: overlayId,
          };
        }
      });
    },
    hideEvaluationBadge(overlays, elementRegistry) {
      if (this.selectedTabData.evalData == null) return;

      this.selectedTabData.evalData.forEach((score) => {
        if (score.overlay != null && score.overlay.type == "eval") {
          if (elementRegistry.get(score.elementId))
            overlays.remove(score.overlay.id);
        }
      });
    },
    setBadgesForMode(overlays, elementRegistry) {
      this.elementRegistry = elementRegistry;
      let self = this;
      let elements = elementRegistry.getAll();
      elements.forEach((elem) => overlays.remove({ element: elem.id }));
      if (
        (this.selectedTabData.elementsToLabel == null ||
          this.selectedTabData.elementsToLabel.length < 1) &&
        !this.selectedTabData.showNumbers
      )
        return;

      if (this.selectedTabData.pxMode) {
        let type = "px";
        for (const element of this.selectedTabData.elementsToLabel.filter(
          (elem) => elem.hasQuestion
        )) {
          const badge = processModelingService.createPxBadge(element);
          if (elementRegistry.get(element.elementId)) {
            badge.html.click(function (e) {
              self.badgeClicked(elementRegistry.get(element.elementId), type);
            });
            let overlayId = overlays.add(element.elementId, badge);
            element.overlay = {
              type: type,
              id: overlayId,
            };
          }
        }
      } else {
        let type = "context";
        for (const element of this.selectedTabData.elementsToLabel.filter(
          (elem) =>
            elem.hasComment ||
            elem.hasDocument ||
            elem.hasDescription ||
            elem.hasMngmtLink
        )) {
          const badge = processModelingService.createContextBadge(element);
          if (elementRegistry.get(element.elementId)) {
            badge.html.click(function (e) {
              let target = "comments";
              switch (e.target.innerHTML) {
                case "forum":
                  target = "comments";
                  break;
                case "description":
                  target = "documents";
                  break;
                case "edit":
                  target = "description";
                  break;
                case "link":
                  target = "mngmtLinks";
                  break;
              }
              self.badgeClicked(
                elementRegistry.get(element.elementId),
                type,
                target
              );
            });
            let overlayId = overlays.add(element.elementId, badge);
            element.overlay = {
              type: type,
              id: overlayId,
            };
          }
        }
      }
      if (this.selectedTabData.showNumbers) {
        let elements = elementRegistry.getAll();
        let self = this;
        this.numbersLoading = true;
        const processElements = async () => {
          // Get all existing numbers before starting
          let nums = this.selectedTabData.elementsToLabel
            .filter((e) => e.elementNum && e.elementNum > 0)
            .map((e) => Number(e.elementNum));

          // Find the current max number
          let maxNum = nums.length ? Math.max(...nums) : 0;

          for (const element of elements.filter(
            (elem) =>
              (this.wantedElements.includes(elem.type) ||
                elem.type.includes("Task")) &&
              (elem.businessObject == null ||
                elem.businessObject.extensionElements == null ||
                elem.businessObject.extensionElements.values == null ||
                elem.businessObject.extensionElements.values[0].taskType !=
                  "postit")
          )) {
            let elem = this.selectedTabData.elementsToLabel.find(
              (e) => e.elementId == element.id
            );
            if (elem == null || elem.elementNum == "0") {
              maxNum += 1; // Increment local maxNum for each new element
              await elementNumberService.saveElementNumber(
                this.selectedTabData.modelInformation.uuid,
                element.id,
                maxNum
              );
            }
          }
        };

        processElements().then(async () => {
          let labelElements =
            await processModelingService.getElementsWithAttachments(this.uuid);

          for (const element of elements.filter(
            (elem) =>
              (this.wantedElements.includes(elem.type) ||
                elem.type.includes("Task")) &&
              (elem.businessObject == null ||
                elem.businessObject.extensionElements == null ||
                elem.businessObject.extensionElements.values == null ||
                elem.businessObject.extensionElements.values[0].taskType !=
                  "postit")
          )) {
            let elem = labelElements.data.find(
              (elem) => elem.elementId == element.id
            );
            const badge = processModelingService.createNumberBadge(
              element,
              elem.elementNum
            );
            let type = "number";
            if (elementRegistry.get(element.id)) {
              badge.html.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  let inputValue = event.target.textContent;
                  // Validate hierarchical number input
                  if (!/^\d+(\.\d+)*$/.test(inputValue)) {
                    alert(
                      "Invalid number format. Use hierarchical format like 1, 1.1, 2.3, etc."
                    );
                    return;
                  }
                  self.alterElementNumerations(
                    self,
                    labelElements.data,
                    inputValue,
                    element.id
                  );
                }
              });
              let overlayId = overlays.add(element.id, badge);
              element.overlay = {
                type: type,
                id: overlayId,
              };
            }
          }
          self.numbersLoading = false;
        });
      }
    },
    alterElementNumerations(self, elements, newNumber, currentElementId) {
      this.numbersLoading = true;
      if (newNumber == null) return;
      // Sort elements by hierarchical number
      const sortedElements = [...elements].sort((a, b) =>
        a.elementNum.localeCompare(b.elementNum, undefined, { numeric: true })
      );

      // Build a mapping of elementId -> current number
      let usedNumbers = new Map();
      sortedElements.forEach((e) => usedNumbers.set(e.elementNum));
      if (newNumber == "0") {
        alert("Die Nummer 0 kann nicht vergeben werden");
        this.processChanged(true);
      } else if (usedNumbers.has(newNumber)) {
        this.$refs.confirmDialog
          .open(
            "Elemente neu nummerieren",
            "Sie haben eine bereits verwendete Nummer vergeben. Um diese Nummer verwenden zu können müssen alle folgenden Elemente neu nummeriert werden. Sollen alle nachfolgenden Elemente neu nummeriert werden?"
          )
          .then(() => {
            usedNumbers.clear();
            sortedElements.forEach((e) =>
              usedNumbers.set(e.elementId, e.elementNum)
            );
            // Assign the new number to the current element and shift others
            let assignedNumbers = new Set();
            usedNumbers.set(currentElementId, newNumber);
            assignedNumbers.add(newNumber);

            sortedElements.forEach((e) => {
              if (e.elementId === currentElementId) return;

              let elementNumber = usedNumbers.get(e.elementId);

              // Resolve conflicts with hierarchical numbers
              while (assignedNumbers.has(elementNumber)) {
                let parts = elementNumber.split(".");
                if (parts.length === 1) {
                  elementNumber = `${parseInt(parts[0]) + 1}`;
                } else {
                  let lastPart = parseInt(parts.pop()) + 1;
                  elementNumber = [...parts, lastPart].join(".");
                }
              }

              usedNumbers.set(e.elementId, elementNumber);
              assignedNumbers.add(elementNumber);
            });

            // Apply updates
            usedNumbers.forEach((num, elementId) => {
              elementNumberService.editElementNumber(
                self.selectedTabData.modelInformation.uuid,
                elementId,
                num
              );
            });
            this.processChanged(true);
          })
          .catch((e) => {
            alert("Diese Nummer wird bereits verwendet!");
            this.processChanged(true);
          });
      } else {
        elementNumberService.editElementNumber(
          self.selectedTabData.modelInformation.uuid,
          currentElementId,
          newNumber
        );
        this.processChanged(true);
      }
    },
    badgeClicked(element, type, target = null) {
      this.onElementClicked(element);
      if (type == "eval") {
        let elementEvals = this.selectedTabData.evalData.filter(
          (elem) => elem.elementId == element.id
        );
        let bo = getBusinessObject(element);
        let elem = {
          id: element.id,
          name: bo.name,
        };
        this.$refs.elementQuestionEvaluation.open(
          elementEvals[0],
          elem,
          this.selectedTabData.currentSurvey
        );
        this.showSidePanel = false;
      } else if (target) {
        this.showSidePanel = true;
        this.sidemenuTab = target;
      }
    },
    async saveFile(reload = false) {
      this.snackbar = {
        value: true,
        status: "secondary",
        msg: "Speichern läuft...",
        loading: true,
        icon: null,
      };
      if (this.selectedTabData.editingMode) {
        this.$refs.bpmnEditor
          .saveFile()
          .then((xml) => {
            this.selectedTabData.diagramXML = xml;
            processModelingService
              .uploadFileAsText(this.selectedTabData.uuid, xml)
              .then(() => {
                if (this.$route.params.changeEditor) {
                  processModelingService
                    .setEditingMode(this.selectedTabData.uuid, null)
                    .then(() => {
                      this.selectedTabData.editingMode = false;
                      if (
                        (this.selectedTabData.modelInformation &&
                          !this.selectedTabData.modelInformation
                            .releaseEnabled) ||
                        this.editAfterPublish
                      ) {
                        localStorage.setItem("editAfterPublish", false);
                        this.editAfterPublish = false;
                        this.fetchDiagram();
                      }
                      this.snackbar = {
                        value: true,
                        status: "success",
                        msg: "Speichern erfolgreich",
                        loading: false,
                        icon: "mdi-check-bold",
                      };

                      setTimeout(() => {
                        this.snackbar = {
                          value: false,
                          status: "success",
                          msg: "",
                          loading: false,
                          icon: "",
                        };
                        if (this.$refs.history != null)
                          this.$refs.history.retrieveHistory();
                        if (reload) window.location.reload();
                      }, 2000);
                    });
                } else {
                  this.snackbar = {
                    value: true,
                    status: "success",
                    msg: "Speichern erfolgreich",
                    loading: false,
                    icon: "mdi-check-bold",
                  };

                  setTimeout(() => {
                    this.snackbar = {
                      value: false,
                      status: "success",
                      msg: "",
                      loading: false,
                      icon: "",
                    };
                    if (this.$refs.history != null)
                      this.$refs.history.retrieveHistory();
                    if (reload) window.location.reload();
                  }, 2000);
                }
              });
          })
          .catch((error) => {
            this.snackbar = {
              value: true,
              status: "error",
              msg: "Speichern fehlgeschlagen",
              loading: false,
              icon: "mdi-close",
            };
            setTimeout(() => {
              this.snackbar = {
                value: false,
                status: "success",
                msg: "",
                loading: false,
                icon: "",
              };
            }, 2000);
          });
      }
    },
    exportXML() {
      var result;
      if (this.selectedTabData.editingMode) {
        result = this.$refs.bpmnEditor.exportXML();
      } else {
        result = this.$refs.bpmnViewer.exportXML();
      }
      if (result != null)
        result
          .then((xml) => {
            this.downloadFile(xml);
          })
          .catch((e) => console.log(e));
    },
    exportPDF() {
      let result;
      if (this.selectedTabData.editingMode) {
        result = this.$refs.bpmnEditor.exportPDF();
      } else {
        result = this.$refs.bpmnViewer.exportPDF();
      }
      if (result != null)
        result
          .then((svg) => {
            this.createPDFandDownload(svg);
          })
          .catch((e) => console.log(e));
    },
    generateReport() {
      let result;
      if (this.selectedTabData.editingMode) {
        alert(
          "Im Bearbeitungsmodus kann kein Bericht erstellt werden. Bitte verlassen Sie den Bearbeitungsmodus um einen Bericht zu erstellen."
        );
        return;
      } else {
        result = this.$refs.bpmnViewer.generateReport();
      }
      if (result != null) {
        result.then((reportData) => {
          processModelingService
            .retrieveModelInformation(this.uuid)
            .then((info) => {
              generateReportStructure(
                reportData,
                this.selectedTabData.modelInformation.uuid,
                this.selectedTabData.fileName,
                info && info.data
                  ? info.data
                  : this.selectedTabData.modelInformation
              );
            });
        });
      }
    },
    createPDFandDownload(svg) {
      const docDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        content: [
          "Prozessmodell für " + this.selectedTabData.fileName,
          {
            svg: svg,
            width: 800,
            height: 500,
            style: "centering",
          },
        ],
        styles: {
          centering: {
            alignment: "center",
          },
        },
      };
      pdfMake
        .createPdf(docDefinition)
        .download(this.selectedTabData.fileName + ".pdf");
    },
    downloadFile(xml) {
      const file = new Blob([xml], { type: "application/xml" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = this.selectedTabData.fileName + ".bpmn";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    async processChanged(needsRefresh = false) {
      this.tooling = "";
      const elementsWithAttachments =
        await processModelingService.getElementsWithAttachments(
          this.selectedTabData.uuid
        );
      var elementsToLabel = elementsWithAttachments.data;

      this.selectedTabData.elementsToLabel = elementsToLabel;
      if (this.selectedTabData.editingMode) {
        this.$refs.bpmnEditor.setBadges();
      } else {
        this.$refs.bpmnViewer.setBadges();
      }
      if (needsRefresh) this.fetchDiagram();
    },

    switchModel(uuid) {
      this.$router.push("/modelEdit/" + uuid);
    },
    fetchDiagram() {
      this.selectedTabData.loadingProgress = 0;
      processModelingService
        .getProcessXml(this.selectedTabData.uuid)
        .then(async (result) => {
          var diagramXML = result.data;
          const elementsWithAttachments =
            await processModelingService.getElementsWithAttachments(
              this.selectedTabData.uuid
            );
          var elementsToLabel = elementsWithAttachments.data;

          this.selectedTabData.diagramXML = diagramXML;
          this.selectedTabData.elementsToLabel = elementsToLabel;
          if (this.$route.params.isNew) {
            this.editModel();
          }
          let isPxMode =
            this.$route.query.mode != null && this.$route.query.mode == "px";

          if (isPxMode) {
            this.selectedTabData.pxMode = true;
            this.selectedTabData.showEvaluation = true;
            this.selectedTabData.preselectedSurvey = this.$route.query.surveyId;
          }
          this.selectedTabData.loadingProgress = 100;
        });
    },
    openQuestionPanel() {
      this.showQuestionPanel = !this.showQuestionPanel;
      if (this.showQuestionPanel) {
        this.showSidePanel = true;
        this.sidemenuTab = "pxQuestions";
      } else {
        this.showSidePanel = false;
      }
    },
    loadColoredElements(elementId) {
      if (this.selectedTabData && this.selectedTabData.editingMode) {
        this.$refs.bpmnEditor.resetColorsInModel();
        this.$refs.bpmnEditor.colorElementInModel(
          elementId,
          this.$vuetify.theme.themes.light.primary,
          ""
        );
      } else {
        this.$refs.bpmnViewer.resetColorsInModel();
        this.$refs.bpmnViewer.colorElementInModel(
          elementId,
          this.$vuetify.theme.themes.light.primary,
          ""
        );
      }
    },
    toggleEvaluation(options) {
      if (options) {
        this.selectedTabData.showEvaluation = options.showEvalVal;
        this.selectedTabData.evalData = options.evalData;
      }
      if (this.selectedTabData.showEvaluation) {
        historyService
          .getHistoryProcessXml(
            options.survey.modelUuid,
            options.survey.commitHash
          )
          .then((res) => {
            this.selectedTabData = Object.assign({}, this.selectedTabData, {
              surveyModel: res.data,
              currentSurvey: options.survey,
            });
            this.$refs.bpmnViewer.setEvaluationBadges();
          });
      } else {
        this.selectedTabData.surveyModel = null;
        if (this.selectedTabData && this.selectedTabData.editingMode) {
          if (this.$refs.bpmnEditor)
            this.$refs.bpmnEditor.hideEvaluationBadges();
        } else {
          if (this.$refs.bpmnViewer)
            this.$refs.bpmnViewer.hideEvaluationBadges();
        }
      }
    },
    generateSurvey() {
      let self = this;
      pxQuestionService.retrievePXProcessQuestions(this.uuid).then((res) => {
        let questions = res.data;
        this.$refs.formDialog
          .open("Bitte geben Sie der Umfrage einen Namen:")
          .then((surveyDetails) => {
            this.$emit("generateSurvey");
            let schema = surveyGenerator.buildSchemaProcessSurvey(
              questions,
              surveyDetails,
              this.uuid
            );

            this.$router.push({
              name: "processSurvey",
              params: {
                schema: schema,
                surveyTitle: surveyDetails.title,
              },
            });
          });
      });
    },
    showSurveyPreview() {
      pxQuestionService.retrievePXProcessQuestions(this.uuid).then((res) => {
        let questions = res.data;
        let schema = surveyGenerator.buildSchemaProcessSurvey(
          questions,
          {},
          this.uuid
        );
        this.$refs.questionPreview.open(schema);
      });
    },
    setSurveyTitle() {
      let self = this;
      pxQuestionService.retrievePXProcessQuestions(this.uuid).then((res) => {
        let questions = res.data;
        this.$refs.formDialog
          .open("Bitte geben Sie der Umfrage einen Namen:")
          .then((surveyDetails) => {
            let schema = surveyGenerator.buildSchemaProcessSurvey(
              questions,
              surveyDetails,
              this.uuid
            );

            pxSurveyService
              .savePXSurvey(schema, 4)
              .then(() => this.$router.push("/surveys"));
          });
      });
    },
    generateTimestamp() {
      processModelingService
        .createTimestampForProcessModel(this.uuid)
        .then((res) => {});
    },
    setSpacerMargin() {
      if (this.selectedTabData.pxMode) {
        return "1";
      } else {
        if (!this.selectedTabData.editingMode && this.canEdit) {
          return "0.7";
        } else if (this.selectedTabData && this.selectedTabData.editingMode) {
          return "0.5";
        }
      }
    },
    async publishFile(item) {
      if (this.selectedTabData.editingMode) {
        let xml = await this.$refs.bpmnEditor.saveFile();
        item.diagramXML = xml;
        this.$refs.publishDialog.open(item).then(async () => {
          await processModelingService.setEditingMode(
            this.selectedTabData.uuid,
            null
          );
          this.selectedTabData.editingMode = false;
          this.selectedTabData.modelInformation = (
            await processModelingService.retrieveModelInformation(
              this.selectedTabData.uuid
            )
          ).data;
          this.fetchDiagram();
        });
      }
    },
    saveReviewFile() {
      this.snackbar = {
        value: true,
        status: "secondary",
        msg: "Speichern läuft...",
        loading: true,
        icon: null,
      };
      this.$refs.bpmnEditor.saveFile().then((xml) => {
        processModelingService
          .saveReviewFile(this.selectedTabData.uuid, xml)
          .then((res) => {
            this.snackbar = {
              value: true,
              status: "success",
              msg: "Speichern erfolgreich",
              loading: false,
              icon: "mdi-check-bold",
            };
            setTimeout(() => {
              this.snackbar = {
                value: false,
                status: "success",
                msg: "",
                loading: false,
                icon: "",
              };
            }, 2000);
          });
      });
    },
  },
};
</script>
<style lang="less">
/*.tabs-item.active:after{*/
/*content : "";*/
/*  position: absolute;*/
/*  left    : 5%;*/
/*  bottom  : 0;*/
/*  height  : 1px;*/
/*  width   : 90%;  !* or 100px *!*/
/*  border-bottom:2px solid var(--v-primary-base);*/
/*}*/
#tabs {
  padding-top: 0px !important;
}
#modelingTooltips {
  width: fit-content;
  height: fit-content;
  z-index: 1;
}
#editmode {
  z-index: 1;
}
#modelingBar {
  position: fixed;
  bottom: 46px;
  margin-left: 25px;
  z-index: 1;
  padding: 12px;
  background-color: #fff;
  box-shadow: 0 0 20px #ededed;
  border: 1px solid #ededed;
  max-height: 50px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;

  :deep .v-label {
    margin-bottom: 0;
  }

  :deep .v-messages {
    display: none;
  }
}
#top,
#left,
#right {
  position: absolute;
}
#modelingButtons {
  background-color: white;
  display: inline;
}
#left,
#right {
  top: 52px;
  bottom: 0px;
}
#left > .v-card,
#right > .v-card {
  z-index: 99;
}
#left {
  left: 0;
}
.commentsOpened {
  right: 350px;
}
.commentsClosed {
  right: 0;
}
#right {
  width: 350px;
  right: 0;
}
.v-window,
.v-window__container,
.v-window-item {
  position: absolute !important;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.sidePanelCollapsed {
  height: 50px;
  position: fixed;
  background-color: #ebebeb;
  border-radius: 5px 2.5px 2.5px 5px;
  right: 0px;
  top: calc(50% - 55px);
  width: 36px;
  text-align: center;
  background: var(--gray-color_4);
  padding-top: 6px;
  /* -moz-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        -webkit-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        -o-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        -ms-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg); */
}
.sidePanelExpand {
  height: 50px;
  position: fixed;
  background-color: #ebebeb;
  border-radius: 5px 2.5px 2.5px 5px;
  right: 350px;
  top: calc(50% - 55px);
  width: 36px;
  text-align: center;
  background: var(--gray-color_4);
  padding-top: 6px;

  /* -moz-transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg);
      -webkit-transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg);
      -o-transform: scale(1) rotate(270deg) translateX(0px) translateY(3-312.5px) skewX(0deg) skewY(0deg);
      -ms-transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg);
      transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg); */
}
.verticalText {
  transform-origin: top left;
  left: 0;
  top: 50%;
  transform: rotate(-90deg) translateX(-100%);
}
</style>
<style lang="less">
.vue-tabs-chrome.theme-custom {
  padding-top: 0;
  background-color: var(--gray-color_4) !important;
  font-size: 0.8rem;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 4;
  .tabs-footer,
  .tabs-divider,
  .tabs-background-before,
  .tabs-background-after {
    display: none;
  }
  .tabs-item {
    cursor: pointer;
  }
  .tabs-content {
    overflow: unset;
    border-top: 1px solid #e4e7ed;
  }
  .tabs-background {
    padding: 0;
  }
  .tabs-background-content {
    border-bottom: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    border-radius: 0;
    background-color: #fff;
  }
  .tabs-content {
    height: 32px;
    width: 100vw;
  }
  .active {
    color: var(--gray-color);
    font-weight: 600;
    .tabs-background {
      position: relative;
      &::before,
      &::after {
        top: 100%;
        left: 0;
        content: "";
        width: 100%;
        height: 1px;
        background-color: #fff;
        z-index: 1;
        position: absolute;
      }
      /* &::before {
        top: 0;
        height: 2px;
        background-color: var(--v-primary-base);
      } */
    }
  }
}
a.v-tab {
  text-transform: none !important;
  letter-spacing: 0;
  font-weight: 600;
}
a.v-tab--active {
  font-weight: 700;
}
.evaluationText {
  position: absolute;
  opacity: 0.92;
  width: 50%;
  left: 27%;
  top: 100px;
  text-align: left;
  font-size: 0.8rem;
  padding: 1rem 2rem;
  background: #f5f5f5;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.text-tag {
  color: var(--v-primary-base);
  position: relative;
  font-weight: 700;
  font-size: 0.7rem;
  padding: 3px 0 0 6px;
  letter-spacing: 0.5px;
  &::after {
    content: "";
    width: 3rem;
    height: 21px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    background-color: var(--v-primary-base);
    opacity: 0.1;
    position: absolute;
    top: 0;
    left: 0;
  }
}
#numerationDisplay {
  position: fixed;
  top: 46px;
  z-index: 1;
  padding: 12px;
  background-color: #fff;
  box-shadow: 0 0 20px #ededed;
  border: 1px solid #ededed;
  max-height: 50px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;

  :deep .v-label {
    margin-bottom: 0;
  }

  :deep .v-messages {
    display: none;
  }
}
.tooltip-text strong {
  color: white; /* Stellt sicher, dass der Text im <strong>-Tag ebenfalls weiß ist */
}
</style>
